export default __webpack_public_path__ + "static/media/chatu.91038d67.png";